/* eslint-disable */
import { WorkatoIdpProviders } from './Components/types';

export const mockConnectionData = [
    {
        displayName: 'Google Workspace',
        image: 'google_workspace.png',
        integrationMessage:
            'This integration is compatible with the cloud versions of Google Workspace.',
        link: 'https://support.auvik.com/hc/en-us/sections/35347377846548-Google-Workspace',
        name: WorkatoIdpProviders.googleWorkspace,
        offboardAccessRemoval:
            '**Access Removal:** Depending on your configuration, other applications using Google SSO may also revoke access when you offboard a user.',
        offboardContent: `- **Deletion**:
  - Permanently removes the user, including their mailbox and personal Drive files.
  - Frees up the user's license immediately.
  - Transfer or migrate data beforehand if needed.
- **Archiving**:
  - Retains the user’s data (mailbox, Drive files) but disables access.
  - May require a separate archived license and isn't available on all plans.
- **Mailbox**:
  - The current integration removes the mailbox when deleting a user.
  - To migrate mailboxes before deletion, use [this link](https://admin.google.com/u/2/ac/dms).
- **Drive Files**:
  - Deleting a user also removes their personal Drive files unless you transfer ownership first.
- **License Removal**:
  - Deleting a user frees up the license.
  - Archiving may affect licensing differently based on your plan.`
    },
    {
        displayName: 'Microsoft Entra ID',
        image: 'msEntraId.png',
        integrationMessage:
            'This integration is compatible with the cloud versions of Microsoft Entra ID.',
        link: 'https://support.auvik.com/hc/en-us/sections/35347497590036-Microsoft-Entra-ID',
        name: WorkatoIdpProviders.microsoftEntraId,
        offboardContent: `- **Deletion:**
  - Permanently removes the user from Microsoft Entra ID and frees up any assigned licenses.
  - If the user has an associated mailbox (e.g., Exchange Online), that mailbox may also be removed.
- **Disable User (Block Sign-In):**
  - Retains the user’s account and data in Microsoft Entra ID but prevents sign-in.
  - Licenses remain assigned unless manually unassigned.
- **Access Removal:**
  - Other applications leveraging Microsoft Entra ID SSO may also revoke access, depending on your configuration.`
    },
    {
        displayName: 'Box',
        image: 'box.png',
        integrationMessage:
            'This integration is compatible with the cloud versions of Box.com.',
        link: 'https://support.auvik.com/hc/en-us/sections/35347183069332-Box',
        name: 'box',
        offboardContent: `- **Deletion**:
  - Offboarding the user will delete their Box.com account.
  - Any content owned by the user must be transferred before deletion to avoid data loss (or use the optional “force delete” in Box, which removes everything the user owns).
- **Best Practice**:
  - Move all user-owned content to an admin-level account or collaborate another user on it prior to deletion.
- **File Migration**:
  - The current integration does not handle file migration automatically.
  - This functionality will be added in the future.`
    },
    {
        displayName: 'Dialpad',
        image: 'dialpad.png',
        link: 'https://support.auvik.com/hc/en-us/sections/35347338996628-Dialpad',
        name: 'dialpad_auvik_saa_s',
        offboardContent: `- **Deletion:**
  - This integration will delete the user from Dialpad.
  - Deleted users are placed in the Deleted Users tab for 72 hours before permanent deletion.
- **Data Retention:**
  - Call history and similar data will be kept based on any existing retention policy.`
    },
    {
        displayName: 'DocuSign',
        image: 'docusign.png',
        link: 'https://support.auvik.com/hc/en-us/sections/35554445295764-Docusign',
        name: 'docusign'
    },
    {
        displayName: 'Dropbox',
        image: 'dropbox.png',
        integrationMessage:
            'This integration is compatible with the cloud versions of Dropbox.com.',
        link: 'https://support.auvik.com/hc/en-us/sections/35347259925652-Dropbox',
        name: 'dropbox',
        offboardContent: `- **Deletion**:
  - Removing a user will delete their Dropbox account, preventing sign-in on both cloud and desktop.
  - Transfer or archive any files before deletion to avoid data loss.`
    },
    {
        displayName: 'RingCentral',
        image: 'ringcentral.png',
        name: 'ringcentral'
    },
    {
        displayName: 'Slack',
        image: 'slack.png',
        integrationMessage:
            'This integration requires Slack Enterprise to automate user offboarding.',
        name: 'slack',
        offboardContent: `- **Deactivation:**
  - The user will be placed in a deactivated state.

- **Data Retention:**
  - Message history and similar data will be retained based on your existing retention settings.`
    },
    {
        displayName: 'Salesforce',
        image: 'salesforce.webp',
        link: 'https://support.auvik.com/hc/en-us/sections/35347561264532-SalesForce',
        name: 'salesforce',
        offboardContent: `- **Deactivation**:
  - Marks the user as inactive, immediately removing their Salesforce.com access and freeing up any relevant license.
- **Salesforce Products**:
  - Other Salesforce products (e.g., Chatter, Einstein) using the same identity are also offboarded when the user is deactivated.`
    },
    {
        displayName: 'Zoom',
        image: 'zoom.png',
        integrationMessage:
            'A premium or enterprise Zoom plan is needed to use this integration',
        link: 'https://support.auvik.com/hc/en-us/sections/35347631023252-Zoom',
        name: 'zoom',
        offboardContent: `- **Offboarding Options**:
  - **Disassociate**: Unlinks the user from your account, reverting them to a free Zoom plan.
  - **Delete**: Permanently removes the user and their data from Zoom.
- **Data Transfer**:
  - Before disassociation or deletion, you can transfer the user’s meetings, webinars, and cloud recordings to another Zoom user.
- **Default Removal**:
  - If no transfers are made, all associated recordings, webinars, and future meetings will be deleted.`
    },
    {
        displayName: 'Smartsheet',
        image: 'smartsheet.png',
        link: 'https://support.auvik.com/hc/en-us/sections/35347578952340-Smartsheet',
        name: 'smartsheet',
        offboardContent: `- **Deactivation:**
  - This integration deactivates the user from the team's plan in Smartsheet.
  - The user will lose access to all owned and shared content that uses the selected account.

- **Local Files:**
  - This integration does not remove any local files that may be stored on the user's workstation.`
    },
    {
        image: 'zendesk.png',
        link: 'https://support.auvik.com/hc/en-us/sections/35347628128532-Zendesk',
        name: 'zendesk',
        displayName: 'Zendesk',
        offboardContent: `- **Deactivation:**
  - This integration deletes the user from Zendesk console in both Support and Admin portals.
  - The user will lose access to Zendesk. This action will unassign all tickets assigned to this agent that have a status other than Closed.`
    },
    {
        displayName: 'Asana',
        image: 'asana.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/35555091308180-Asana',
        name: 'asana',
        offboardContent: `- **Deletion & Data Retention:** Offboarding a user in Asana permanently removes their active account while preserving all historical data including tasks, comments, and project contributions for audit and continuity purposes. If the user is an admin or owns many project assets, it's recommended to reassign ownership of any tasks or projects managed to another user.`
    },
    {
        displayName: 'Hubspot',
        image: 'hubspot.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/35555212528788-Hubspot',
        name: 'hubspot',
        offboardContent: `- **Deletion & Data Retention:** Offboarding a user in HubSpot permanently disables their account while retaining all historical data such as emails, contacts, deals, tickets, notes, and activity logs. Review and update any integrations, API tokens, or workflows that may be tied to the offboarded user to ensure continuity and security.`
    },
    {
        displayName: 'Wrike',
        image: 'wrike.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/35555157220500-Wrike',
        name: 'wrike'
    },
    {
        displayName: 'Intercom',
        image: 'intercom.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/35555156322708-Intercom',
        name: 'intercom'
    },
    {
        displayName: 'Airtable',
        image: 'airtable.png',
        link: 'https://support.auvik.com/hc/en-us/sections/36485550768020-Airtable',
        name: 'airtable'
    },
    {
        displayName: 'Miro',
        image: 'miro.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/36485158266900-Miro',
        name: 'miro_board'
    },
    {
        displayName: 'PagerDuty',
        image: 'pagerduty.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/37452687796244-PagerDuty',
        name: 'pagerduty'
    },
    {
        displayName: 'Duo Security',
        image: 'duo.png',
        link: 'https://support.auvik.com/hc/en-us/sections/37452730427668-Cisco-Duo',
        name: 'duo_security'
    },
    {
        displayName: 'Okta',
        image: 'okta.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/37485612603924-Okta',
        name: 'okta'
    },
    {
        displayName: 'Salesloft',
        image: 'salesloft.svg',
        link: 'https://support.auvik.com/hc/en-us/sections/37452566902932-Salesloft',
        name: 'sales_loft'
    }
];
